import { shallowReactive } from 'vue'

const $formErrors = shallowReactive({})

export default $formErrors